import * as Sentry from '@sentry/browser'
import { getConsole } from 'lib/getConsole'
import { experimentEnabled } from 'lib/utils'
const console = getConsole('lib', 'sentry')

// VERSION_STRING is populated by CI
const SENTRY_RELEASE = process.env.VERSION_STRING
const SENTRY_ENABLED = process.env.NODE_ENV === 'production' && experimentEnabled('send_js_errors_to_sentry')

if (SENTRY_ENABLED) {
  console.log('Sentry init')
  Sentry.init({
    dsn: 'https://3875f3f816364fb882a2a396f2390596@sentry.io/1414014',
    release: SENTRY_RELEASE,
    // for now, disable global error handling code for less noise.
    // once we have eliminated the errors we're catching in
    // our ErrorBoundary implementations, we can turn on GlobalHandlers
    integrations: integrations => integrations.filter(i => i.name !== 'GlobalHandlers' && i.name !== 'TryCatch'),
    beforeSend: (event, hint) => {
      console.log('sending sentry event', event, hint)
      return event
    }
  })
}

export const logErrorBoundActivation = (error, errorInfo) => {
  // Sentry.* should be a noop if Sentry.init hasn't been called, but
  // let's guard this anyways to be on the safe side
  if (SENTRY_ENABLED) {
    return new Promise((resolve, reject) => {
      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key])
        })
        // captureExecption returns sentry event UUID
        const eventId = Sentry.captureException(error)
        resolve(eventId)
      })
    })
  } else {
    return Promise.resolve('sentry_disabled')
  }
}
